import React from 'react';
import { createPlugin } from './pm-plugins/main';
import { GlobalStylesWrapper } from './ui/extensions/synced-block/components/GlobalStyles';
export var syncedBlockPlugin = function syncedBlockPlugin() {
  return {
    name: 'syncedBlock',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'syncedBlockPlugin',
        plugin: createPlugin
      }];
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(GlobalStylesWrapper, null);
    }
  };
};